import Vue from 'vue';

import '@mdi/font/css/materialdesignicons.css' 
import es from "vuetify/es5/locale/es";
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar'


Vue.use(Vuetify, { components: {
  VSnackbar,
  VBtn,
  VIcon
} })
Vue.use(VuetifyToast)
export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: "#0e345b",
        accent: "#5585bf",
        secondary: "#f0efed",
        tertiary: '#495057',
        
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: '#ffa21a'
        // secondary: '#b0bec5',
        // anchor: '#8c9eff',
      },
    },
    icons: {
      //iconfont: "mdiSvg",
       iconfont: 'mdi',
    },
    lang: {
      locales: { es },
      current: "es"
    }
  },
});

